import React from "react"
import { Modal as BootstrapModal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import NiceModal, { useModal } from "@ebay/nice-modal-react"

const ZeefAgentRequiredModal = NiceModal.create(() => {
  const modal = useModal()

  return (
    <BootstrapModal centered size="md" isOpen={modal.visible} toggle={() => modal.hide()}>
      <ModalHeader>ZEEF Agent Configuration Required</ModalHeader>
      <ModalBody>
        <p>The ZEEF AI assistant has not been configured for your organization yet.</p>
        <p>
          Please contact a user administrator to set up the ZEEF agent. Users with <strong>user-admin</strong> permissions
          can configure this from any ZEEF chat window.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => modal.hide()}>
          OK
        </Button>
      </ModalFooter>
    </BootstrapModal>
  )
})

export default ZeefAgentRequiredModal
